import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
// @material-ui/icons
import Email from "@material-ui/icons/Email";
// import LockOutline from "@material-ui/icons/LockOutline";
import { setData } from "../../utils/util";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "../../components/CustomInput/CustomInput";
import Button from "components/CustomButtons/Button";
import Btn from "@material-ui/core/Button";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";

// import { login } from "../../actions/admin_action";

import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";
import { hist } from "../../index";

import logo_white from "assets/img/logo_white.svg";
import Loader from "assets/img/loader.svg";

import toastr from "toastr";
import { login$ } from "../../redux/actions/login";

import axios from "../../config/axios";

toastr.options = {
  closeButton: true
};

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      userInfo: {
        email: "",
        password: ""
      },
      cardAnimaton: "cardHidden"
    };
  }

  componentDidMount() {
    this.timeOutFunction = setTimeout(
      function() {
        this.setState({ cardAnimaton: "" });
      }.bind(this),
      700
    );
  }

  componentWillUnmount() {
    clearTimeout(this.timeOutFunction);
    this.timeOutFunction = null;
  }

  changeData = event => {
    let { id, value } = event.target;
    let { userInfo } = this.state;
    this.setState({
      userInfo: {
        ...userInfo,
        [id]: value
      }
    });
  };

  blurData = event => {
    let { id, value } = event.target;
    let { userInfo } = this.state;
    this.setState({
      userInfo: {
        ...userInfo,
        [id]: value.trim()
      }
    });
  };

  _handleKeyPress = e => {
    if (e.key === "Enter") {
      this.login();
    }
  };

  login = () => {
    let { userInfo } = this.state;
    let { email, password } = userInfo;
    for (let key in userInfo) {
      if (userInfo[key] === "") {
        if (
          key === "password" &&
          !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)
        ) {
          toastr.error(`Valid Email is required!`);
          return true;
        }
        toastr.error(
          `${key.charAt(0).toUpperCase() + key.slice(1)} is required!`
        );
        return true;
      }
    }
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
      toastr.error(`Valid Email is required!`);
      return true;
    }
    let obj = {
      email: email.toLowerCase(),
      password
    };
    this.setState({
      loader: true
    });
    // this.props.handleLogin(obj);
    // console.log("vs", this.props.login);
    // debugger;
    axios
      .post("users/login", obj)
      .then(res => {
        console.log(res,'res in loginpage')
        if (res.status === 200
          //  && res.data.data.user_type === 1
           ) {
          let response = res.data.data;
          setData("adminData", {
            authToken: response.token,
            assignRoles: ["Manage Users"]
          });
          localStorage.setItem("name", response.name);
          localStorage.setItem("email", response.email);
          localStorage.setItem("id", response.id);
          this.setState({
            loader: false
          });
          hist.push("/admin/manageevents");
        } else {
          toastr.error("Incorrect Credentials!");
          this.setState({
            loader: false
          });
        }
      })
      .catch(error => {
        toastr.error("Incorrect Credentials!");
        this.setState({
          loader: false
        });
      });
  };

  goToForgotPass = () => {
    hist.push("/admin/pages/forgetpassword");
    // let { userInfo } = this.state;
    // let { email, password } = userInfo;
    // if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
    //   toastr.error(`Valid Email is required!`);
    // } else {
    //   const requestBody = { email };
    //   axios
    //     .post("admin/users/forgot-password", requestBody)
    //     .then(res => {
    //       toastr.success(res.data.message);
    //     })
    //     .catch(err => {
    //       toastr.error(err.response.data.message);
    //     });
    // }
  };

  componentWillReceiveProps = nextProps => {
    let { error } = nextProps;
    if (error) {
      this.setState({
        error
      });
    }
    this.props.removeError();
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={6} md={4}>
            <form style={{ textAlign: "center" }}>
              <img
                style={{ height: "30px", marginBottom: "20px" }}
                src={logo_white}
                alt="ISEAS Logo"
              />
              <Card login className={classes[this.state.cardAnimaton]}>
                <CardHeader
                  className={`${classes.cardHeader} ${classes.textCenter}`}
                  color="iseas"
                >
                  <h4 className={classes.cardTitle}>Log In</h4>
                </CardHeader>
                <CardBody>
                  <CustomInput
                    labelText="Email"
                    id="email"
                    formControlProps={{
                      fullWidth: true
                    }}
                    type="text"
                    onChange={this.changeData}
                    onBlur={this.blurData}
                    required={true}
                    inputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Email className={classes.inputAdornmentIcon} />
                        </InputAdornment>
                      )
                    }}
                  />
                  <CustomInput
                    labelText="Password"
                    id="password"
                    formControlProps={{
                      fullWidth: true
                    }}
                    type="password"
                    onChange={this.changeData}
                    required={true}
                    onKeyPress={this._handleKeyPress}
                    inputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Icon className={classes.inputAdornmentIcon}>
                            lock_outline
                          </Icon>
                        </InputAdornment>
                      )
                    }}
                  />
                </CardBody>
                <div
                  style={{
                    textAlign: "center",
                    margin: "10px",
                    position: "relative"
                  }}
                >
                  <Button
                    variant="contained"
                    color="iseas"
                    onClick={this.login}
                    style={{ width: "52%" }}
                  >
                    Login
                  </Button>
                  {this.state.loader ? (
                    <div className="loader_login">
                      <img src={Loader} alt="loader"/>
                    </div>
                  ) : null}
                </div>
                <div style={{ textAlign: "center", margin: "10px" }}>
                  <Btn
                    color="iseas"
                    onClick={this.goToForgotPass}
                    style={{ width: "52%" }}
                  >
                    Forgot Password ?
                  </Btn>
                </div>
              </Card>
            </form>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

LoginPage.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    login: state.login
  };
};

const mapDispatchToProps = dispatch => {
  return {
    handleLogin: body => dispatch(login$.trigger(body))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(loginPageStyle)(LoginPage));



// WEBPACK FOOTER //
// ./src/views/Pages/LoginPage.jsx